import { IS_MOCK_MODE } from 'src/constants/featureFlag'
import { SERVER_URL } from 'src/constants/serverUrl'
import { MediumItem } from 'src/legacy_modules/entities/medium-item/entity'
import { requestPut } from 'src/legacy_modules/server/request'

type Params = {
  items: Array<{
    medium_item_uid: string
    index: number
    small_items: Array<{
      small_item_uid: string
      index: number
    }>
  }>
}

export type UpdateMediumItemOrderResponse = {
  medium_item_uid: string
  index: number
  small_items: Array<{
    small_item_uid: string
    index: number
  }>
}

export const updateOrder = async ({
  uid,
  trialUid,
  mediumItems,
}: {
  uid: string
  trialUid: string
  mediumItems: MediumItem[]
}): Promise<UpdateMediumItemOrderResponse[]> => {
  if (IS_MOCK_MODE) {
    return []
  }

  const params = toParams(mediumItems)

  const res = await requestPut<UpdateMediumItemOrderResponse[]>({
    url: `${SERVER_URL}/trials/${trialUid}/templates/${uid}/medium_items`,
    params: params,
  })

  return res.data
}

// フロントでは normalize して持っている medium item, small item を、API が期待する JSON 形式にする
const toParams = (mediumItems: MediumItem[]): Params => {
  const items: Params['items'] = mediumItems.map((mediumItem, mediumIndex) => {
    return {
      medium_item_uid: mediumItem.uid,
      index: mediumIndex,
      small_items: Object.values(mediumItem.smallItemMap).map(smallItem => {
        return {
          small_item_uid: smallItem.uid,
          index: smallItem.index,
        }
      }),
    }
  })

  return {
    items,
  }
}
